module.exports = __webpack_public_path__ + "img/maestro.62547fb6.png";